import { PreviewCourseActivityPage } from '@hendrx/core/courses';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/courses/preview/$courseDraftId/$categoryId/$activityId')({
  component: PreviewCourseActivityPageComponent
});

function PreviewCourseActivityPageComponent() {
  const { activityId } = Route.useParams();

  return <PreviewCourseActivityPage activityId={activityId} />;
}
